var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('v-progress-circular',{staticClass:"loader__spinner",attrs:{"indeterminate":"","width":_vm.width,"color":_vm.color}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }